import DlContainer from "./main.vue"

/* istanbul ignore next */
DlContainer.install = function(Vue) {
  Vue.component(DlContainer.name, DlContainer)
}

export default DlContainer
